import { MassMailingForm } from '../../forms/mailingForms/massMailing.form';
import EmailHistory from './EmailHistory';

export const MassMailing = () => {
    return <>
        <MassMailingForm/>
        <EmailHistory/>
    </>
};
